import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import "../scss/components/bio.scss"

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <div className="bioWrap">
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                minWidth: 80,
                minHeight: 0,
                border: `4px solid #fff`,
                borderRadius: `100%`,
                marginBottom: `16px`,
              }}
              imgStyle={{
                borderRadius: `50%`,
              }}
            />
            <h4 className="author">&lt; {author} /&gt;</h4>
            <div className="bioText">
              <p>『Web制作 / 写真 / 映像 / 旅 / 筋トレ』をベースに、のんびり生きてます_(┐「ε:)_福岡の田舎でクリエイターチーム【<a href="https://fump.tech/" target="_blank" rel="noopener noreferrer">Fump</a>】として活動しています。<a href="https://twitter.com/search?q=%23%E3%83%88%E3%83%BC%E3%82%AF%E3%83%B3%E3%83%8F%E3%82%A6%E3%82%B9&src=typd" target="_blank" rel="noopener noreferrer">#トークンハウス</a> にも参加してます〜</p>
              <div className="snsLinks">
                <a className="blogLink" href="https://taroken.org/" target="_blank" rel="noopener noreferrer">Blog</a>
                <a className="twitterLink" href={`https://twitter.com/${social.twitter}`} target="_blank" rel="noopener noreferrer">Twitter</a>
                <a className="instagramLink" href={`https://instagram.com/${social.instagram}`} target="_blank" rel="noopener noreferrer">Instagram</a>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 80, height: 80) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
          instagram
        }
      }
    }
  }
`

export default Bio
